import { curry, get } from 'lodash';
import COLORS from './colors';

const BRANDCOLORS = {
  danger: COLORS.carnationRed,
};

export const theme = {
  colors: { ...COLORS, ...BRANDCOLORS },
  header: {
    height: '46px',
  },
  footer: {
    height: '42px',
  },
  sidebar: {
    width: '250px',
    backgroundColor: COLORS.sanMarinoBlue,
    variants: {
      closed: {
        width: '46px',
      },
    },
  },
  newFlow: {
    header: {
      height: '46px',
    },
    footer: {
      height: '42px',
    },
  },
};

export const getThemeProp = curry((key: string, props: any): string =>
  get(props, `theme.${key}`, get(theme, key)),
);

/**
/* extract prop or return alternative
/* @param {string} prop
/* @param {any} [alternative]
 */

export const prop = (name: string, alternative?: string | boolean) => (
  props: any,
) => get(props, name, alternative);
